import { z } from 'zod';

import { uuidValidator } from '../../validators';

export const DeleteWordGroupsSchema = z.object({
  ids: z
    .array(uuidValidator)
    .min(1, 'At least one word group ID must be provided'),
});

export type IDeleteWordGroupsDto = z.infer<typeof DeleteWordGroupsSchema>;
